'use strict';
var populations = document.querySelectorAll('.population');
var total = 0;
for(var i = 0; i < populations.length; i++){
    var text = populations[i].textContent;
    var withoutSymbols = text.replaceAll(',', '');
    var toNumber = Number(withoutSymbols);
    total += toNumber;
}
var average = total / populations.length;
document.querySelector('.total-population').textContent = total.toLocaleString();
document.querySelector('.average-population').textContent = average.toLocaleString();

//# sourceMappingURL=js_get_data_DOM.f5b65253.js.map
